import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';


/**
 * Prevent access to routes if access-token is not present.
 * 
 * @export
 * @class AuthGuard
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private _router: Router,
    public auth: AuthService
  ) { }

  canActivate(): boolean {

    if (this.auth.isLoggedIn) {
      return true;
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }
}